import { EMI_TENURES_REQUEST, EMI_TENURES_SUCCESS, EMI_TENURES_ERROR } from 'actions/PaymentActions/PaymentActions';
import { LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';

export const INITIAL_STATE = {};

export default function emiTenures(state = INITIAL_STATE, action = {}) {
	switch (action.type) {
		case EMI_TENURES_REQUEST:
			return { ...state, [action.key]: { asyncStatus: LOADING } };
		case EMI_TENURES_SUCCESS:
			// FIXME: The key here is wrong. For both EMI with interest and
			// debit card emi, the key would be the same.
			return { ...state, [action.key]: { ...action.data, asyncStatus: SUCCESS } };
		case EMI_TENURES_ERROR:
			return { ...state, [action.key]: { error: action.error, asyncStatus: ERROR } };
		default:
			return state;
	}
}
